<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        @if (back && ids) {
          <button class="mr-0 mr-sm-16" mat-icon-button (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
          </button>
        }
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom>location_city</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom>{{'main.communications' | translate}}</span>
      </div>
      <!-- / APP TITLE -->


      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>

        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->

        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->


    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <mat-table class="products-table"
        #table [dataSource]="tags"
        matSort
        [@animateStagger]="{value:'50'}"
        fusePerfectScrollbar>


        <ng-container cdkColumnDef="type">
          <mat-header-cell [ngClass]="'customWidthClass'" *cdkHeaderCellDef mat-sort-header>{{'frontUser.type' |
            translate}}
          </mat-header-cell>
          <mat-cell *cdkCellDef="let comm" [ngClass]="'customWidthClass'">
            @if (comm.type === 'sms') {
              <mat-icon>textsms</mat-icon>
            }
            @if (comm.type === 'mail') {
              <mat-icon>email</mat-icon>
            }
            @if (comm.type === 'serial') {
              <mat-icon>receipt</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="names">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let comm">
            <mat-icon (click)="openBottomSheet($event, comm)">supervisor_account</mat-icon>

          </mat-cell>
        </ng-container>


        <ng-container cdkColumnDef="description">
          <mat-header-cell [ngClass]="'customWidthClass1'" *cdkHeaderCellDef mat-sort-header>{{'event.description' |
            translate}}
          </mat-header-cell>
          <mat-cell [ngClass]="'customWidthClass1'" *cdkCellDef="let comm">
            @if (comm.type !== 'mail') {
              <span>{{comm.description}}</span>
            }
            @if (comm.type === 'mail') {
              <span>{{comm?.data?.subject}}</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="name">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'event.title' |
            translate}}
          </mat-header-cell>
          <mat-cell *cdkCellDef="let comm">
            <span>
              {{comm.name}}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="sent">
          <mat-header-cell [ngClass]="'customWidthClass1'" *cdkHeaderCellDef mat-sort-header>{{'event.sent' |
            translate}}
          </mat-header-cell>
          <mat-cell *cdkCellDef="let comm">
            <span>
              {{comm.createdAt | date: 'EEE, d. MMMM HH:mm'}}
            </span>
          </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

        <mat-row *cdkRowDef="let comm; columns: displayedColumns;"
          class="product"
          matRipple
          (click)="editType(comm)">
        </mat-row>

      </mat-table>
      @if (tags.filteredData.length === 0) {
        <div class="no-data-msg">
          <span class="mat-headline-6">{{'main.noData' | translate}}</span>
        </div>
      }
      <mat-paginator #paginator
        [length]="tags.filteredData.length"
        [pageIndex]="0"
        [pageSize]="50"
        [pageSizeOptions]="[25, 50, 100]">
      </mat-paginator>

    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
